export enum MyFilesConstants {
  MY_FILES_BASE_URL = "my-files",
  SECTIONS_URL = "sections",
}
